/* Corsa Forged quote builder */
(function () {
  var STORE_KEY = 'corsa-quote-last';

  function store(get, val) {
    try {
      if (get) return JSON.parse(window.sessionStorage.getItem(STORE_KEY) || 'null');
      window.sessionStorage.setItem(STORE_KEY, JSON.stringify(val));
    } catch (e) { return null; }
    return null;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  var CHECK_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var CHEVRON_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

  /* Turn a native <select data-cq-finish> into a swatch dropdown. The select stays in the form and carries the value. */
  function enhanceFinish(select, onChange) {
    var label = select.id ? document.querySelector('label[for="' + select.id + '"]') : null;
    var wrap = el('div', 'cq__pick');
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);
    select.classList.add('cq__sr');
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');

    var btn = el('button', 'cq__trig');
    btn.type = 'button';
    btn.id = select.id + '-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var sw = el('span', 'cq__sw'); sw.setAttribute('aria-hidden', 'true');
    var name = el('span', 'cq__trig-name');
    var note = el('span', 'cq__trig-note');
    var chev = el('span'); chev.innerHTML = CHEVRON_SVG; chev.style.display = 'inline-flex';
    btn.appendChild(sw); btn.appendChild(name); btn.appendChild(note); btn.appendChild(chev);
    wrap.appendChild(btn);

    if (label) {
      if (!label.id) label.id = select.id + '-lbl';
      label.setAttribute('for', btn.id);
      btn.setAttribute('aria-labelledby', label.id + ' ' + btn.id);
    }

    var list = el('div', 'cq__list');
    list.id = select.id + '-list';
    list.setAttribute('role', 'listbox');
    if (label) list.setAttribute('aria-labelledby', label.id);
    list.hidden = true;
    btn.setAttribute('aria-controls', list.id);

    var optButtons = [];
    Array.prototype.forEach.call(select.children, function (child) {
      var group = el('div');
      var opts = [];
      if (child.tagName === 'OPTGROUP') {
        group.setAttribute('role', 'group');
        group.setAttribute('aria-label', child.label);
        group.appendChild(el('div', 'cq__group-title', child.label));
        opts = Array.prototype.slice.call(child.children);
      } else {
        opts = [child];
      }
      opts.forEach(function (o) {
        var b = el('button', 'cq__opt');
        b.type = 'button';
        b.setAttribute('role', 'option');
        b.setAttribute('data-value', o.value);
        var s = el('span', 'cq__sw'); s.setAttribute('aria-hidden', 'true'); s.style.background = o.getAttribute('data-bg') || '#ccc';
        b.appendChild(s);
        b.appendChild(el('span', 'cq__opt-name', o.value));
        if (o.getAttribute('data-note')) b.appendChild(el('span', 'cq__opt-note', o.getAttribute('data-note')));
        var ck = el('span', 'cq__check'); ck.innerHTML = CHECK_SVG; b.appendChild(ck);
        b.addEventListener('click', function () {
          select.value = o.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          close(true);
        });
        group.appendChild(b);
        optButtons.push(b);
      });
      list.appendChild(group);
    });
    wrap.appendChild(list);

    function sync() {
      var o = select.options[select.selectedIndex];
      if (!o) return;
      sw.style.background = o.getAttribute('data-bg') || '#ccc';
      name.textContent = o.value;
      note.textContent = o.getAttribute('data-note') || '';
      optButtons.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-value') === o.value ? 'true' : 'false'); });
    }

    function open() {
      document.dispatchEvent(new CustomEvent('cq:close-all', { detail: wrap }));
      list.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      var cur = list.querySelector('[aria-selected="true"]') || optButtons[0];
      if (cur) { cur.focus(); cur.scrollIntoView({ block: 'nearest' }); }
    }
    function close(refocus) {
      if (list.hidden) return;
      list.hidden = true;
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      if (refocus) btn.focus();
    }

    btn.addEventListener('click', function () { list.hidden ? open() : close(true); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
    });
    list.addEventListener('keydown', function (e) {
      var i = optButtons.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); if (optButtons[i + 1]) optButtons[i + 1].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (i > 0) optButtons[i - 1].focus(); }
      else if (e.key === 'Home') { e.preventDefault(); optButtons[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); optButtons[optButtons.length - 1].focus(); }
      else if (e.key === 'Escape') { e.preventDefault(); close(true); }
      else if (e.key === 'Tab') { close(false); }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(false); });
    document.addEventListener('cq:close-all', function (e) { if (e.detail !== wrap) close(false); });
    select.addEventListener('change', function () { sync(); if (onChange) onChange(); });
    sync();
  }

  function init(root) {
    if (root.__cqReady) return;
    root.__cqReady = true;
    var form = root.querySelector('form');
    if (!form) return;

    /* Thank-you state after Shopify reloads the page */
    var done = root.querySelector('[data-cq-done]');
    if (done) {
      var last = store(true);
      if (last) {
        var nm = done.querySelector('[data-cq-thanks-name]');
        if (nm && last.name) nm.textContent = ', ' + last.name.split(' ')[0];
        var dl = done.querySelector('[data-cq-done-sum]');
        if (dl && last.rows) {
          last.rows.forEach(function (r) { dl.appendChild(el('dt', null, r[0])); dl.appendChild(el('dd', null, r[1])); });
          dl.hidden = false;
        }
      }
      done.scrollIntoView({ block: 'center' });
      done.focus({ preventScroll: true });
      return;
    }

    form.setAttribute('novalidate', '');
    var q = function (sel) { return root.querySelector(sel); };
    var val = function (k) { var n = q('[data-cq-sum-src="' + k + '"]'); return n ? n.value : ''; };
    var rear = q('[data-cq-rear]');
    var frontTitle = q('[data-cq-front-title]');
    var error = q('[data-cq-error]');
    var isTwo = root.getAttribute('data-two') === 'true';

    function finishText(k) {
      var s = q('[data-cq-sum-src="' + k + '"]');
      if (!s) return '';
      if (s.value === 'Custom color') {
        var c = s.closest('.cq__finish').querySelector('[data-cq-custom] input');
        return c && c.value ? 'Custom: ' + c.value : 'Custom color';
      }
      return s.value;
    }

    function update() {
      var stag = (form.querySelector('[data-cq-setup]:checked') || {}).value === 'Staggered';
      if (rear) {
        rear.hidden = !stag;
        rear.querySelectorAll('select').forEach(function (s) { s.disabled = !stag; });
      }
      if (frontTitle) frontTitle.textContent = stag ? 'Front' : 'All four wheels';

      root.querySelectorAll('[data-cq-finish]').forEach(function (s) {
        var box = s.closest('.cq__finish').querySelector('[data-cq-custom]');
        if (!box) return;
        var on = s.value === 'Custom color';
        box.hidden = !on;
        box.querySelector('input').disabled = !on;
      });

      var veh = [val('year'), val('make'), val('model')].filter(Boolean).join(' ');
      var size = stag
        ? 'F ' + val('fd') + ' x ' + val('fw') + '  /  R ' + val('rd') + ' x ' + val('rw')
        : val('fd') + ' x ' + val('fw') + ' all four';
      var fit = (form.querySelector('[data-cq-fit]:checked') || {}).value || '';
      var fin = isTwo ? 'Face: ' + finishText('face') + '  /  Barrel: ' + finishText('barrel') : finishText('face');
      var out = function (k, t) { var n = q('[data-cq-sum-out="' + k + '"]'); if (n) n.textContent = t; };
      var wheelSel = q('[data-cq-sum-src="wheel"]');
      var wheelOut = q('[data-cq-sum-out="wheel"]');
      var wheel = wheelSel ? (wheelSel.value || 'Not sure yet') : (wheelOut ? wheelOut.textContent : '');
      if (wheelSel) out('wheel', wheel);
      out('vehicle', veh || 'Add your vehicle');
      out('size', size);
      out('fit', fit);
      out('finish', fin);
      return { wheel: wheel, veh: veh, size: size, fit: fit, fin: fin };
    }

    root.querySelectorAll('[data-cq-finish]').forEach(function (s) { enhanceFinish(s, update); });
    form.addEventListener('change', update);
    form.addEventListener('input', function (e) {
      if (e.target.getAttribute('aria-invalid') === 'true' && e.target.value.trim()) e.target.removeAttribute('aria-invalid');
      update();
    });
    update();

    form.addEventListener('submit', function (e) {
      var missing = [];
      form.querySelectorAll('[required]').forEach(function (f) {
        var bad = !f.value.trim() || (f.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.value.trim()));
        if (bad) { f.setAttribute('aria-invalid', 'true'); missing.push(f); } else { f.removeAttribute('aria-invalid'); }
      });
      if (missing.length) {
        e.preventDefault();
        if (error) error.hidden = false;
        missing[0].focus();
        return;
      }
      if (error) error.hidden = true;
      var s = update();
      var nameField = form.querySelector('[data-cq-name]');
      store(false, {
        name: nameField ? nameField.value.trim() : '',
        rows: [['Wheel', s.wheel], ['Vehicle', s.veh], ['Size', s.size], ['Fitment', s.fit], ['Finish', s.fin]]
      });
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
    });
  }

  function boot() { document.querySelectorAll('[data-cq]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
